import React from 'react';
import {
    Checkbox,
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useTranslation} from "react-i18next";

const ConnectorFormCodPaymentMethods = ({ connectorPaymentMethods, codPaymentMethods, setCodPaymentMethods, ...rest }) => {
    const {t} = useTranslation('connector');

    return (
        <Autocomplete
            multiple
            options={connectorPaymentMethods}
            onChange={ (event, PMs) => setCodPaymentMethods(PMs.map(pm => pm.id)) }
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            value={connectorPaymentMethods.filter(cpm => codPaymentMethods.includes(cpm.id))}
            renderOption={(option, { selected }) => (
                <React.Fragment>
                    <Checkbox
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option.name}
                </React.Fragment>
            )}
            renderInput={(params) => (
                <TextField {...params} label={t('label.cod_payment_methods')} placeholder={t('label.payment_method')} />
            )}
        />
    )
}

export default ConnectorFormCodPaymentMethods;